/* src/app/app.component.scss */
:host {
  display: block;
  min-height: 100vh;
  background: #05070d;
}
/*# sourceMappingURL=app.component.css.map */
